import { Identifiable, Milestone } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleMarkMilestoneAsCompleted(
  milestone: Identifiable<Milestone>,
  { milestone: m }: Boundaries["markMilestoneAsCompleted"]["success"],
): Identifiable<Milestone> {
  return m.uuid === milestone.uuid ? m : milestone;
}

export { handleMarkMilestoneAsCompleted };
